<template>
	<div>
		<el-dialog title="设置" :visible.sync="dialogVisible" width="600px" @close="resetForms">
			<el-form class="ml-6" :rules="rules" :model="ruleForm" ref="ruleForm" label-width="220px">
				<template v-for="item in formItems">
					<el-form-item :label="item.label" :prop="item.numField" :key="item.numField">
						<el-radio v-model="ruleForm[item.limitField]" :label="1">限制</el-radio>
						<el-radio v-model="ruleForm[item.limitField]" @change="val => change(val, item.numField)" :label="2">不限制</el-radio>
						<div v-show="ruleForm[item.limitField] === 1" class="mt-4 input-content">
							<span>最多可下载</span>
							<el-input-number
								v-model.number="ruleForm[item.numField]"
								class="ml-8 mr-8 input-number"
								type="text"
								placeholder="请输入"
								:min="0"
							></el-input-number>
							<span>次</span>
						</div>
					</el-form-item>
				</template>
			</el-form>
			<span slot="footer" class="footer">
				<el-button @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submit" :loading="loading">保存</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import { saveMaterialConfig, getMaterialConfig } from '@/api/contentLibray';
import debounce from 'lodash/debounce';
export default {
	props: {
		partner_list: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		const validateUserAuthorimitNum = function(rule, value, callback) {
			if (value <= 0) {
				callback(new Error('请输入正整数'));
			} else {
				callback();
			}
		};
		return {
			dialogVisible: false,
			loading: false,
			formItems: [
				{
					label: '达人运营可下载次数(单素材)',
					limitField: 'userDownloadLimit',
					numField: 'userDownloadLimitNum',
				},
				{
					label: '达人可下载次数(单素材)',
					limitField: 'authorDownloadLimit',
					numField: 'authorDownloadLimitNum',
				},
			],
			ruleForm: {
				authorDownloadLimit: 1,
				authorDownloadLimitNum: 0,
				userDownloadLimit: 1,
				userDownloadLimitNum: 0,
			},
			rules: {
				authorDownloadLimitNum: [{ required: true, validator: validateUserAuthorimitNum, trigger: 'blur' }],
				userDownloadLimitNum: [{ required: true, validator: validateUserAuthorimitNum, trigger: 'blur' }],
			},
		};
	},
	methods: {
		change(val, itemProp) {
			if (val === 2) {
				this.ruleForm[itemProp] = 1;
				this.$refs['ruleForm'].clearValidate([itemProp]);
			}
		},

		async show() {
			await this.getDownloadRulesFn();
			this.dialogVisible = true;
		},
		async getDownloadRulesFn() {
			const { ruleForm } = this;
			const { authorDownloadLimitNum, userDownloadLimitNum } = await getMaterialConfig();
			ruleForm.authorDownloadLimitNum = !authorDownloadLimitNum ? 1 : authorDownloadLimitNum;
			ruleForm.authorDownloadLimit = authorDownloadLimitNum ? 1 : 2;
			ruleForm.userDownloadLimitNum = !userDownloadLimitNum ? 1 : userDownloadLimitNum;
			ruleForm.userDownloadLimit= userDownloadLimitNum ? 1 : 2;
		},
		submit: debounce(async function() {
			await this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				this.loading = true;
				try {
					const { code } = await saveMaterialConfig({
						authorDownloadLimitNum: this.ruleForm.authorDownloadLimitNum && this.ruleForm.authorDownloadLimit === 1 ? this.ruleForm.authorDownloadLimitNum : 0,
						userDownloadLimitNum: this.ruleForm.userDownloadLimitNum && this.ruleForm.userDownloadLimit === 1 ? this.ruleForm.userDownloadLimitNum : 0,
					});
					if (code == 0) {
						this.$message.success('操作成功');
						this.$emit('refreshList');
						this.dialogVisible = false;
					}
					this.loading = false;
				} catch {
					this.loading = false;
				}
			});
		}, 300),
		//重置弹框表单
		resetForms() {
			Object.assign(this.$data, this.$options.data());
			this.$refs.ruleForm.resetFields();
			this.$nextTick(() => {
				this.$refs.ruleForm.clearValidate();
			});
		},
	},
};
</script>
<style lang="less" scoped>
/deep/ .footer.el-button--small {
	width: 76px;
}
.input-content{
	width: 272px;
	position: relative;
	padding: 8px 16px 8px 16px;
	background: #F7F8F9;
	border-radius: 4px;
	border: 1px solid #F0F1F5;
	box-sizing: border-box;
}
.input-number{
	/deep/ .el-input-number__increase{
		background: #F5F7FA;
		border-left: 1px solid #EAEBF0
	}
	/deep/ .el-input-number__decrease{
		background: #F5F7FA;
		border-right: 1px solid #EAEBF0;
	}
}
</style>
